/**
 * Checks if the board is a Template board.
 */
export function checkIsTemplate({
  isTemplate,
  permissionLevel,
  premiumFeatures,
}: {
  isTemplate?: boolean;
  permissionLevel?: 'enterprise' | 'org' | 'private' | 'public';
  premiumFeatures?: readonly string[];
}): boolean {
  if (!isTemplate) {
    return false;
  }

  // public templates are free
  if (permissionLevel === 'public') {
    return true;
  }

  // privateTemplates are a paid feature
  if (premiumFeatures?.includes('privateTemplates')) {
    return true;
  }

  return false;
}
